<template>
  <span>
    <el-button type='primary' @click='showColumnSetDialogMD' icon='sys sys-columns' class='navbarbtn'> 栏 目</el-button>

    <!-- 修改用户栏目设置弹出框 -->
    <el-dialog v-dialogDrag title='用户栏目设置' :visible.sync='showColumnSetDialogInner' width='75%' top='10px'
      append-to-body>
      <el-table :data='columnInfo' row-key='ColumnCode' border height='400px' v-loading='columnSetLoading'
        :cell-style='tableCellStyle' :header-cell-style='tableHeaderCellStyle' size='medium' ref='columnsTable'
        :row-style='columnRowStyle' style='margin-top: -20px;' @row-click='columnRowClick'>
        <el-table-column type='index' label='序号' header-align='center' align='center' width='60' fixed></el-table-column>
        <el-table-column prop='ColumnCode' label='列编号' width='160' show-overflow-tooltip fixed></el-table-column>
        <el-table-column prop='ColumnName' label='列名称' width='160' fixed>
          <template #default='scope'>
            <span>{{scope.row.ColumnName}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='DisplayFlag' label='是否显示' width='80'>
          <template #header>
            <span style='color: blue;'>是否显示</span>
          </template>
          <template #default='scope'>
            <select v-if='scope.row.ColumnCode === editColumnCode' class='tableInput'
              v-model='scope.row.DisplayFlag' style='width: 60px;'>
              <option v-for='displayFlag in displayFlags' :key='displayFlag.code' :value='displayFlag.code'>{{displayFlag.name}}</option>
            </select>
            <span v-else>{{columnSpecialStringDisplayTransform(scope.row.DisplayFlag, 'DisplayFlag')}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='Seq' label='显示顺序' width='80'>
          <template #header>
            <span style='color: blue;'>显示顺序</span>
          </template>
          <template #default='scope'>
            <input v-if='scope.row.ColumnCode === editColumnCode' @change='numberChange(scope.row, "Seq")'
              v-model='scope.row.Seq' style='width: 60px;' class='tableInput'/>
            <span v-else>{{scope.row.Seq}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='Width' label='宽度' width='80'>
          <template #header>
            <span style='color: blue;'>宽度</span>
          </template>
          <template #default='scope'>
            <input v-if='scope.row.ColumnCode === editColumnCode' @change='numberChange(scope.row, "Width")'
              v-model='scope.row.Width' style='width: 60px;' class='tableInput'/>
            <span v-else>{{scope.row.Width}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='DataType' label='数据类型' width='120'>
          <template #default='scope'>
            <select v-if='scope.row.ColumnCode === editColumnCode' class='tableInput' disabled
              v-model='scope.row.DataType' style='width: 100px;'>
              <option v-for='dataType in dataTypes' :key='dataType.code' :value='dataType.code'>{{dataType.name}}</option>
            </select>
            <span v-else>{{columnSpecialStringDisplayTransform(scope.row.DataType, 'DataType')}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='CustomDisplay' label='自定义显示' width='100'>
          <template #header>
            <span style='color: blue;'>自定义显示</span>
          </template>
          <template #default='scope'>
            <select v-if='scope.row.ColumnCode === editColumnCode' class='tableInput'
              v-model='scope.row.CustomDisplay' style='width: 80px;'>
              <option v-for='customDisplay in customDisplays' :key='customDisplay.code' :value='customDisplay.code'>{{customDisplay.name}}</option>
            </select>
            <span v-else>{{columnSpecialStringDisplayTransform(scope.row.CustomDisplay, 'CustomDisplay')}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='TextAlign' label='对齐方式' width='100'>
          <template #header>
            <span style='color: blue;'>对齐方式</span>
          </template>
          <template #default='scope'>
            <select v-if='scope.row.ColumnCode === editColumnCode' class='tableInput'
              v-model='scope.row.TextAlign' style='width: 80px;'>
              <option v-for='textAlign in textAligns' :key='textAlign.code' :value='textAlign.code'>{{textAlign.name}}</option>
            </select>
            <span v-else>{{columnSpecialStringDisplayTransform(scope.row.TextAlign, 'TextAlign')}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='DateFormat' label='日期格式' width='180'>
          <template #header>
            <span style='color: blue;'>日期格式</span>
          </template>
          <template #default='scope'>
            <input v-if='scope.row.ColumnCode === editColumnCode && scope.row.DataType === "4"'
              v-model='scope.row.DateFormat' style='width: 160px;' class='tableInput'/>
            <span v-else>{{scope.row.DateFormat}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='Color' label='颜色' width='120'>
          <template #header>
            <span style='color: blue;'>颜色</span>
          </template>
          <template #default='scope'>
            <input v-if='scope.row.ColumnCode === editColumnCode'
              v-model='scope.row.Color' style='width: 100px;' class='tableInput'/>
            <span v-else>{{scope.row.Color}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='DecimalDigits' label='小数位数' width='80'>
          <template #header>
            <span style='color: blue;'>小数位数</span>
          </template>
          <template #default='scope'>
            <input v-if='scope.row.ColumnCode === editColumnCode' @change='numberChange(scope.row, "DecimalDigits")'
              v-model='scope.row.DecimalDigits' style='width: 60px;' class='tableInput'/>
            <span v-else>{{scope.row.DecimalDigits}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='OrderType' label='排序方式' width='100'>
          <template #header>
            <span style='color: blue;'>排序方式</span>
          </template>
          <template #default='scope'>
            <select v-if='scope.row.ColumnCode === editColumnCode' class='tableInput'
              v-model='scope.row.OrderType' style='width: 80px;'>
              <option v-for='orderType in orderTypes' :key='orderType.code' :value='orderType.code'>{{orderType.name}}</option>
            </select>
            <span v-else>{{columnSpecialStringDisplayTransform(scope.row.OrderType, 'OrderType')}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='OrderSeq' label='排序序号' width='80'>
          <template #header>
            <span style='color: blue;'>排序序号</span>
          </template>
          <template #default='scope'>
            <input v-if='scope.row.ColumnCode === editColumnCode' @change='numberChange(scope.row, "OrderSeq")'
              v-model='scope.row.OrderSeq' style='width: 60px;' class='tableInput'/>
            <span v-else>{{scope.row.OrderSeq}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='FixedFlag' label='固定位置' width='100'>
          <template #header>
            <span style='color: blue;'>固定位置</span>
          </template>
          <template #default='scope'>
            <select v-if='scope.row.ColumnCode === editColumnCode' class='tableInput'
              v-model='scope.row.FixedFlag' style='width: 80px;'>
              <option v-for='fixedFlag in fixedFlags' :key='fixedFlag.code' :value='fixedFlag.code'>{{fixedFlag.name}}</option>
            </select>
            <span v-else>{{columnSpecialStringDisplayTransform(scope.row.FixedFlag, 'FixedFlag')}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='Sortable' label='是否可排序' width='100'>
          <template #header>
            <span style='color: blue;'>是否可排序</span>
          </template>
          <template #default='scope'>
            <select v-if='scope.row.ColumnCode === editColumnCode' class='tableInput'
              v-model='scope.row.Sortable' style='width: 80px;'>
              <option v-for='sortable in sortables' :key='sortable.code' :value='sortable.code'>{{sortable.name}}</option>
            </select>
            <span v-else>{{columnSpecialStringDisplayTransform(scope.row.Sortable, 'Sortable')}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='ShowOverflowTooltip' label='是否显示Tip' width='120'>
          <template #header>
            <span style='color: blue;'>是否显示Tip</span>
          </template>
          <template #default='scope'>
            <select v-if='scope.row.ColumnCode === editColumnCode' class='tableInput'
              v-model='scope.row.ShowOverflowTooltip' style='width: 100px;'>
              <option v-for='showOverflowTooltip in showOverflowTooltips' :key='showOverflowTooltip.code' :value='showOverflowTooltip.code'>{{showOverflowTooltip.name}}</option>
            </select>
            <span v-else>{{columnSpecialStringDisplayTransform(scope.row.ShowOverflowTooltip, 'ShowOverflowTooltip')}}</span>
          </template>
        </el-table-column>

        <el-table-column prop='Description' label='列描述' width='200' show-overflow-tooltip>
          <template #header>
            <span style='color: blue;'>列描述</span>
          </template>
          <template #default='scope'>
            <input v-if='scope.row.ColumnCode === editColumnCode'
              v-model='scope.row.Description' style='width: 180px;' class='tableInput'/>
            <span v-else>{{scope.row.Description}}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class='dialogButtomBtn'>
        <el-select v-model='tableInfo.PageSize' placeholder='每页数量'
          style='width:100px; margin-right:20px;' size='mini'>
          <el-option v-for='pageSize in pageSizes' :key='pageSize' :label='pageSize' :value='pageSize'>
          </el-option>
        </el-select>
        <el-button type='warning' @click='returnDefaultTableColumn()' size='mini'>恢复默认</el-button>
        <el-button type='primary' @click='saveUserTableColumn()' size='mini'>保存</el-button>
        <el-button @click='columnsReSort()' size='mini'>排序</el-button>
        <el-button @click='updateUserColumnSetDialogReset()' size='mini'>重置</el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import table from '@/components/sys/Table'
import code from '@/components/sys/Code'

export default {
  name: 'TableColumnSet',
  props: {
    columnInfo: {
      default: function () {
        return []
      },
      type: Array
    },
    tableInfo: {
      default: function () {
        return {}
      },
      type: Object
    },
    showColumnSetDialog: {
      default: false,
      type: Boolean
    },
    changeShowColumnSetDialog: {
      default: false,
      type: Boolean
    },
    columnSetLoading: {
      default: false,
      type: Boolean
    }
  },

  data: function () {
    return {
      showColumnSetDialogInner: false,
      editColumnCode: '',
      dataTypes: [],
      displayFlags: [],
      textAligns: [],
      customDisplays: [],
      orderTypes: [],
      fixedFlags: [],
      sortables: [],
      showOverflowTooltips: [],
      pageSizes: [10, 20, 50, 100, 200]
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  watch: {
    showColumnSetDialog: function (newVal, oldVal) {
      const that = this
      that.editColumnCode = ''
      that.showColumnSetDialogInner = newVal
    },
    changeShowColumnSetDialog: function (newVal, oldVal) {
      const that = this
      that.editColumnCode = ''
      that.showColumnSetDialogInner = that.$props.showColumnSetDialog
    }
  },

  created: async function () {
    const that = this
    if (that.dataTypes.length <= 0 || that.displayFlags.length <= 0 ||
      that.textAligns.length <= 0 || that.customDisplays.length <= 0 ||
      that.orderTypes.length <= 0 || that.fixedFlags.length <= 0 ||
      that.sortables.length <= 0 || that.showOverflowTooltips.length <= 0) {
      const codes = that.codes
      that.dataTypes = code.getCode(codes, 'SYS_Table_DataType')
      that.displayFlags = code.getCode(codes, 'SYS_Table_DisplayFlag')
      that.textAligns = code.getCode(codes, 'SYS_Table_TextAlign')
      that.customDisplays = code.getCode(codes, 'SYS_Table_CustomDisplay')
      that.orderTypes = code.getCode(codes, 'SYS_Table_OrderType')
      that.fixedFlags = code.getCode(codes, 'SYS_Table_FixedFlag')
      that.sortables = code.getCode(codes, 'SYS_Table_Sortable')
      that.showOverflowTooltips = code.getCode(codes, 'SYS_Table_ShowOverflowTooltip')
    }
  },

  methods: {
    showColumnSetDialogMD: function () {
      this.$emit('showColumnSetDialogMD')
    },

    updateUserColumnSetDialogReset: function () {
      this.$emit('updateUserColumnSetDialogReset')
    },

    saveUserTableColumn: function () {
      this.$emit('saveUserTableColumn')
    },

    returnDefaultTableColumn: function () {
      this.$emit('returnDefaultTableColumn')
    },

    columnRowClick: function (row, event, column) {
      const that = this
      that.editColumnCode = row.ColumnCode
    },

    columnSpecialStringDisplayTransform: function (val, columnCode) {
      const that = this
      if (columnCode === 'DisplayFlag') {
        return table.specialStringDisplayTransform(val, that.displayFlags)
      } else if (columnCode === 'DataType') {
        return table.specialStringDisplayTransform(val, that.dataTypes)
      } else if (columnCode === 'CustomDisplay') {
        return table.specialStringDisplayTransform(val, that.customDisplays)
      } else if (columnCode === 'TextAlign') {
        return table.specialStringDisplayTransform(val, that.textAligns)
      } else if (columnCode === 'OrderType') {
        return table.specialStringDisplayTransform(val, that.orderTypes)
      } else if (columnCode === 'FixedFlag') {
        return table.specialStringDisplayTransform(val, that.fixedFlags)
      } else if (columnCode === 'Sortable') {
        return table.specialStringDisplayTransform(val, that.sortables)
      } else if (columnCode === 'ShowOverflowTooltip') {
        return table.specialStringDisplayTransform(val, that.showOverflowTooltips)
      }
    },

    columnRowStyle: function (row, rowIndex) {
      if (row.row.DisplayFlag === '0') {
        return { 'background-color': '#CCCCCC' }
      } else {
        return { 'background-color': '#FFFFFF' }
      }
    },

    columnsReSort: function () {
      const that = this
      for (let i = 0; i < that.columnInfo.length; i++) {
        for (let j = i; j < that.columnInfo.length; j++) {
          if ((that.columnInfo[i].DisplayFlag === that.columnInfo[j].DisplayFlag &&
            parseInt(that.columnInfo[i].Seq) > parseInt(that.columnInfo[j].Seq)) ||
            (that.columnInfo[j].DisplayFlag === '1' && that.columnInfo[i].DisplayFlag === '0')) {
            const tempRow = that.columnInfo[i]
            that.columnInfo[i] = that.columnInfo[j]
            that.columnInfo[j] = tempRow
          }
        }
      }
      for (let i = 0; i < that.columnInfo.length; i++) {
        that.columnInfo[i].Seq = i + 1
      }
      that.$refs.columnsTable.doLayout()
    },

    numberChange: function (obj, code) {
      if (obj[code] === '') {
        return
      }
      try {
        obj[code] = parseFloat(obj[code])
        if (isNaN(obj[code])) {
          obj[code] = 0
        }
      } catch (err) {
        obj[code] = 0
      }
    },

    tableCellStyle: function () {
      return { padding: '0px' }
    },

    tableHeaderCellStyle: function () {
      return { padding: '4px', 'background-color': '#f5f7fa' }
    }
  }
}
</script>

<style scoped>
.dialogButtomBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.tableInput {
  height: 20px;
  line-height: 20px;
  border: 0;
  background-color: transparent;
  padding: 0;
}
</style>
